import type { ICDTenCode } from "@/types/medical-codes";

import { type CodeDescriptionMap, normalizeCodes } from "./code-descriptions";

/** ICD-10 code (upper-cased) -> its reference description. */
export type Icd10DescriptionMap = CodeDescriptionMap;

export const normalizeIcd10Codes = normalizeCodes;

/**
 * Index a lookup response by upper-cased code, dropping description-less rows.
 *
 * `shortDesc`, not `longDesc`: the printed bill names the diagnosis on one row
 * beside the code, the way Practice Fusion prints "Myalgia, unspecified site".
 * The long form is a clinical elaboration that would crowd the block without
 * telling a biller anything the short form doesn't.
 */
export const buildIcd10DescriptionMap = (
  codes: ICDTenCode[],
): Icd10DescriptionMap =>
  Object.fromEntries(
    codes
      .filter((c) => c.code?.trim() && c.shortDesc?.trim())
      .map((c) => [c.code.trim().toUpperCase(), c.shortDesc.trim()]),
  );
